import { Citations, RetrieveCitations } from "./Citations";
import { Feedback } from "./Feedback";
import { MessagingStatus, type MessagingMessage } from "@/model/messaging";
import { TypingIcon } from "@deputy-ai/icons";
import { memo } from "react";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

const _Text = ({ message }: { message: MessagingMessage }) => {
  return (
    <>
      <div className="webchat-bubble prose flex flex-col text-sm text-pretty text-inherit">
        <Markdown
          remarkPlugins={[remarkGfm]}
          rehypePlugins={[rehypeRaw]}
          components={{
            a(props) {
              const { children, ...rest } = props;
              if (props.href && isYoutubeEmbedLink(props.href)) {
                return <YoutubeVideo href={props.href} />;
              }

              return (
                <a {...rest} target="_blank">
                  {children}
                </a>
              );
            },
          }}
        >
          {message.payload.message}
        </Markdown>
        <Citations message={message} />
        <RetrieveCitations message={message} />
        <Feedback message={message} />
      </div>
      {(message.status === MessagingStatus.Typing ||
        message.status === MessagingStatus.Pending) && (
        <TypingIcon className="h-6 text-gray-600" />
      )}
    </>
  );
};

export const Text = memo(_Text);
Text.displayName = "Text";

function isYoutubeEmbedLink(href?: string) {
  return href?.startsWith("https://www.youtube.com/embed");
}

function YoutubeVideo({ href }: { href: string }) {
  return (
    <iframe
      width="360"
      height="240"
      src={href}
      title="YouTube video player"
      className="border-0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerPolicy="strict-origin-when-cross-origin"
      allowFullScreen
    ></iframe>
  );
}
